import app from '../app.first';
import { each } from 'lodash';

app.Main = class extends app.Component {
	onReady () {
		each($('.open[data-reveal]'), e => {
			$(e).foundation('open');
		});

		$(document).on('blur', 'input:text', e => {
			const $t = $(e.target);
			const newValue = $t.val().trim();

			$t.val(newValue);
			if (newValue) {
				$t.trigger('change');
			}
		});

		this.$el.on('click', '[data-open-cv]', e => {
			let src = $(e.target).closest('[data-open-cv]').data('openCv');
			if (src) {
				if (Foundation.MediaQuery.current === 'small') {
					window.open(src, '_blank');
				} else {
					$('#candidate-cv iframe').attr('src', src)
					$('#candidate-cv').foundation('open');
				}
			}
		});

		this.$el.on('click', '[data-open-ad]', e => {
			let src = $(e.target).closest('[data-open-ad]').data('openAd');
			if (src) {
				if (Foundation.MediaQuery.current === 'small') {
					window.open(src, '_blank');
				} else {
					$('#ad-preview iframe').attr('src', src)
					$('#ad-preview').foundation('open');
				}
			}
		});

		this.$el.on('click', '[data-open-video]', e => {
			let srcUris = $(e.target).closest('[data-open-video]').data('openVideo');
			$('#candidate-video video').empty();
			each (srcUris, (src, type) => {
				$('#candidate-video video')
					.append($('<source>', { type, src }))
					.get(0)
					.load();
			});

			/**
			 * Delay modal opening to give video time to load
			 */
			setTimeout(() => {
				$('#candidate-video').foundation('open');
			}, 100);
		});

		this.$el.on('click', '[data-open-audio]', e => {
			let srcUris = $(e.target).closest('[data-open-audio]').data('openAudio');
			$('#candidate-audio audio').empty();
			each (srcUris, (src, type) => {
				$('#candidate-audio audio')
					.append($('<source>', { type, src }))
					.get(0)
					.load();
			});

			/**
			 * Delay modal opening to give video time to load
			 */
			setTimeout(() => {
				$('#candidate-audio').foundation('open');
			}, 100);
		});
	}
}